import useSWRMutation from "swr/mutation";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { ServicesURL } from "@utils/utilsApi";
import { ActivityWizardData } from "../../../types";

// ─── MOCK (rimuovere insieme a IS_MOCKED quando BE pronto) ─────────────
const IS_MOCKED = true;
const MOCK_DELAY = 300;
// ───────────────────────────────────────────────────────────────────────

interface UseDraftActivityArgs {
  corporateId: string;
}

interface DraftResponse {
  id: number;
  draft: true;
}

export const useDraftActivity = ({ corporateId }: UseDraftActivityArgs) => {
  const url = ServicesURL.v2DraftActivity.replace(":idCorporate", corporateId);

  const { trigger, isMutating } = useSWRMutation<
    DraftResponse,
    Error,
    string,
    ActivityWizardData
  >(url, async (u: string, { arg }: { arg: ActivityWizardData }) => {
    if (IS_MOCKED) {
      return new Promise<DraftResponse>((resolve) => {
        setTimeout(() => resolve({ id: Date.now(), draft: true }), MOCK_DELAY);
      });
    }
    return fetcher<ActivityWizardData>(u, MethodType.POST, arg);
  });

  return { saveDraft: trigger, isSavingDraft: isMutating };
};
